export default __webpack_public_path__ + "static/media/Mt Greeff Teleport.030434f5.PNG";